export const SPOOLED_STATE_DETAILS = ['INB', 'NGD', 'TRM', 'OFL', 'RPS', 'CHK', 'FIK', 'FID'];

export enum SUMMARY_STATE {
    CREATED = 'CREATED',
    OPEN = 'OPEN',
    SPOOLED = 'SPOOLED',
    CLOSED = 'CLOSED',
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED',
}

export enum ORDER_FORM {
    BILL_PAYMENT = 'BILL_PAYMENT',
    TAX_PAYMENT = 'TAX_PAYMENT',
    TREASURY_PAYMENT = 'TREASURY_PAYMENT',
    QUICK_INSURANCE = 'QUICK_INSURANCE',
    E_INVOICE = 'E_INVOICE',
    INSURANCE = 'INSURANCE',
    CARD_REPAYMENT = 'CARD_REPAYMENT',
    CREDIT_CARD_REPAYMENT = 'CREDIT_CARD_REPAYMENT',
    SEPA_PAYMENT = 'SEPA_PAYMENT',
    NON_SEPA_PAYMENT = 'NON_SEPA_PAYMENT',
    SALARY_PAYMENT = 'SALARY_PAYMENT',
    INTRACOMPANY_PAYMENT = 'INTRACOMPANY_PAYMENT',
    SEPA_DD_CORE_PAYMENT = 'SEPA_DD_CORE_PAYMENT',
    SEPA_DD_B2B_PAYMENT = 'SEPA_DD_B2B_PAYMENT',
    TRUST_PAYMENT = 'TRUST_PAYMENT',
    ERSTE_CONFIRMING_INVOICE_PAYMENT = 'ERSTE_CONFIRMING_INVOICE_PAYMENT',
    CASH_PER_POST_PAYMENT = 'CASH_PER_POST_PAYMENT',
    CHEQUE_PAYMENT = 'CHEQUE_PAYMENT',
    SWIFT_PAYMENT = 'SWIFT_PAYMENT',
    BUNDLE_PAYMENT = 'BUNDLE_PAYMENT',
    DATACARRIER_PAYMENT = 'DATACARRIER_PAYMENT',
    DATACARRIER_SALARY_PAYMENT = 'DATACARRIER_SALARY_PAYMENT',
    DATACARRIER_DD_INSTRUCTIONS_PAYMENT = 'DATACARRIER_DD_INSTRUCTIONS_PAYMENT',
    QUICK_OWN_TRANSFER = 'QUICK_OWN_TRANSFER',
    OWN_FX_PAYMENT = 'OWN_FX_PAYMENT',
    DATACARRIER_SINGLE_DEBIT_MULTIPLE_CREDIT = 'DATACARRIER_SINGLE_DEBIT_MULTIPLE_CREDIT',
    DOMESTIC_DD_OUT = 'DOMESTIC_DD_OUT',
    DOMESTIC_DD_IN = 'DOMESTIC_DD_IN',
    DOMESTIC_BULK_PAYMENT = 'DOMESTIC_BULK_PAYMENT',
}

export enum FLAG {
    FILE_REQUIRED = 'fileRequired',
    DRAFT_REQUESTED = 'draftRequested',
    URGENT = 'urgent',
    INDIVIDUAL_CONDITIONS = 'individualConditions',
    SPLIT_FEES = 'splitFees',
    DEBIT_PAYER = 'debitPayer',
    DEBIT_PAYEE = 'debitPayee',
    SIGNABLE = 'signable',
    REDOABLE = 'redoable',
    COLLECTIVE = 'collective',
    FIRST_SIGNED = 'firstSigned',
    TRANSFER_DATE_WHEN_SIGNING_DONE = 'transferDateWhenSigningDone',
    REQUESTED_DUE_DATE_WHEN_SIGNING_DONE = 'requestedDueDateWhenSigningDone',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    TRANSFER_DUE_DATE_WHEN_SIGNING_DONE = 'transferDateWhenSigningDone',
    DATACARRIER = 'datacarrier',
    EDITABLE = 'editable',
    DELETABLE = 'deletable',
    CANCELABLE = 'cancelable',
    DECOMPOSABLE = 'decomposable',
    COLLECTIVE_SIGNING = 'collectiveSigning',
    COLLECTIVE_SIGNING_FINAL_SIGNATURE = 'collectiveSigningFinalSignature',
    BANK_CODE_PREFERRED = 'bankCodePreferred',
    MARK_RECEIVER_AS_TRUSTED_CONTACT = 'markReceiverAsTrustedContact',
    SIMILAR_ORDER_WARNING = 'similarOrderWarning',
    SIMILAR_ORDER_SAME_AMOUNT_WARNING = 'similarOrderSameAmountWarning',
    AMOUNT_EDIT_ALLOWED = 'amountEditAllowed',
    PARTIAL_CONTENT_PERMISSION = 'partialContentPermission',
    NO_CONTENT_PERMISSION = 'noContentPermission',
    COMBINABLE = 'combinable',
    FORWARDABLE = 'forwardable',
    REVOCABLE = 'revocable',
    PRINTABLE = 'printable',
    NOT_ALLOWED_BANK_CODE_WARNING = 'notAllowedBankCodeWarning',
    SIX_DIGITS_BANK_CODE_WARNING = 'sixDigitsBankCodeWarning',
    NINE_DIGITS_BANK_CODE_WARNING = 'nineDigitsBankCodeWarning',
    GENERAL_BANK_CODE_WARNING = 'generalBankCodeWarning',
    DRAFTABLE = 'draftable',
    UNDRAFTABLE = 'undraftable',
    AUTO_RECREATED = 'autoRecreated',
    STOP_REGULAR_EXECUTIONS_AFTER_DEATH = 'stopRegularExecutionsAfterDeath',
    /**
     * If 1st level bulk is outcome of Data import split
     */
    IMPORTED = 'imported',
    MULTIPLE_SENDER_ACCOUNTS = 'multipleSenderAccounts',
    SENDER_REFERENCE_EDIT_ALLOWED = 'senderReferenceEditAllowed',
    CREATED_BY_SCHEDULER = 'createdByScheduler',
    PAYEE_VERIFICATION_REQUIRED = 'payeeVerificationRequired',
    FILE_UPLOAD_ALLOWED = 'fileUploadAllowed',
    TRACKABLE = 'trackable',
}

export enum REQUEST_TO_PAY_FLAG {
    CANCELLED = 'requestToPayCancelled',
    APPROVED = 'requestToPayApproved',
    REJECTED = 'requestToPayRejected',
    BLOCK_ALLOWED = 'requestToPayBlockAllowed',
}

export enum PAYMENT_ENDPOINT {
    DOMESTIC = 'domestic',
    SEPA = 'sepa',
    INTERNATIONAL = 'international',
}

export enum AUTHORIZATION_STATUS {
    CREATOR = 'CREATOR',
    AVAILABLE = 'AVAILABLE',
    REQUIRED = 'REQUIRED',
    REQUESTED = 'REQUESTED',
    SIGNED = 'SIGNED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    OK = 'OK',
    ERROR = 'ERROR',
}

export enum AUTHORIZATION_ACTION {
    EDIT = 'EDIT',
    CANCEL = 'CANCEL',
    DELETE = 'DELETE',
    SIGN = 'SIGN',
    FORWARD = 'FORWARD',
}

export enum AUTHORIZATION_FLAG {
    CREATOR = 'creator',
}

export enum EMAIL_OWNER {
    SENDER = 'SENDER',
    RECEIVER = 'RECEIVER',
}

export enum DIRECT_DEBIT_SEQUENCE_TYPE {
    FRST = 'FRST',
    FNAL = 'FNAL',
    RCUR = 'RCUR',
    OOFF = 'OOFF',
}

export enum INSTRUCTION_CODE {
    HOLD = 'HOLD',
    PHOB = 'PHOB',
}

export enum RATE_TYPE {
    FORWARD = 'FORWARD',
    SPOT = 'SPOT',
    CASHADVANCE = 'CASHADVANCE',
}

export enum ITEM_TYPE {
    PAYMENT_ORDER = 'PAYMENT_ORDER',
    BUNDLE = 'BUNDLE',
    DATA_CARRIER = 'DATACARRIER',
    BULK = 'BULK',
}

export enum ORDER_SOURCE {
    MY_LICENSE = 'MY_LICENSE',
    OTHER_LICENSE = 'OTHER_LICENSE',
}

export enum ORDER {
    asc = 'asc',
    desc = 'desc',
}

export enum CHANNEL_ID {
    GB_MANUAL = 'GB_MANUAL',
    GB_IMPORTED = 'GB_IMPORTED',
    S_FILE_SERVICE = 'S_FILE_SERVICE',
    FILE_TRANSFER_PLUGIN = 'FILE_TRANSFER_PLUGIN',
    TBPRO = 'TBPRO',
    MBS = 'MBS',
    EBICS = 'EBICS',
    UNKNOWN = 'UNKNOWN',
}

export enum INTERMEDIATE_ACCOUNT_TYPE {
    AIIN = 'AIIN',
    BBAN = 'BBAN',
    CUID = 'CUID',
    UPIC = 'UPIC',
}

export enum RECONFIRMATION_REASON {
    POSSIBLE_FRAUD = 'POSSIBLE_FRAUD',
}
